import toastr from "toastr";
import heic2any from "heic2any";
import { Pagination, Col } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import { PaginationItem, PaginationLink } from "reactstrap";
import {
  FetchCityListdata,
  FetchCountryListdata,
  FetchStateListdata,
} from "helpers/fetch_country_state_helper";
import { useDispatch, useSelector } from "react-redux";
import {
  listCustomArt,
  postArtRequest,
  postCustomArt,
  uploadArt,
  uploadMultiFile,
} from "store/actions";
import moment from "moment-timezone";
import { Oval } from "react-loader-spinner";
import { DatePicker } from "antd";
import { useNavigate } from "react-router-dom";
import FullfillmentDialog from "Pages/Profile/fullfillmentDialog";
const initialState = {
  description: "",
  size: "",
  frame_type: "",
  full_name: "",
  email: "",
  phone: "",
  wp_num: "",
  address: "",
  country: { name: "", code: "" },
  city: "",
  state: { name: "", code: "" },
  zip: "",
  budgetCurrency: "",
  budget: "",
  user_id: "",
  file_name: "",
  link: "",
  water_mark_image_link: "",
  refrence_arts: [],
  timeline:""
};

const CustomArtForm = () => {
  const [dates, setDates] = useState([]);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initialState);
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [ViewArt, setViewArt] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [images, setimages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageURLs, setImageURLs] = useState([]);
  const { user } = useSelector((s) => s?.Login);
  const { CustomArts } = useSelector((s) => s.CustomArt);
  const loading2 =useSelector((s) => s.CustomArt.loading);
  const { authToken } = useSelector((s) => s.Login);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({});

  const sizes = [
    "40 x 50",
    "45 x 60",
    "50 x 60",
    "50 x 75",
    "60 x 75",
    "60 x 90",
    "75 x 100",
    "90 x 120",
    "120 x 150",
    "Other"
  ];
  const frames = [
    "Wood Frame",
    "Metal Frame",
    "Floating Frame",
    "Acrylic Frame",
    "PVC or Plastic Frame",
    "Composite or MDF Frame",
    "Bamboo or Eco-friendly Wood Frame",
    "Ornate (Carved) Frame",
    "Rustic Reclaimed Wood Frame",
    "Minimalist Box Frame",
    "Other"
  ];
  const todaysDate = moment().format("YYYY-MM-DD");
  useEffect(() => {
    setData(CustomArts);
  }, [CustomArts]);
  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.description)
      newErrors.description = "Description is required.";
    if (!formData.size) newErrors.size = "Size is required.";
    if (!formData.frame_type) newErrors.frame_type = "Frame type is required.";
    if (!formData.full_name) newErrors.full_name = "Full name is required.";
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid email is required.";
    if (!formData.phone || !/^\d{7,15}$/.test(formData.phone))
      newErrors.phone = "Valid phone number is required.";
    if (!formData.wp_num || !/^\d{7,15}$/.test(formData.wp_num))
      newErrors.wp_num = "Valid WhatsApp number is required.";
    if (!formData.address) newErrors.address = "Address is required.";
    if (!formData.country) newErrors.country = "Country is required.";
    if (!formData.city) newErrors.city = "City is required.";
    if (!formData.state) newErrors.state = "State is required.";
    if (!formData.zip || !/^\d{4,10}$/.test(formData.zip))
      newErrors.zip = "Valid ZIP code is required.";
    if (!formData.budgetCurrency)
      newErrors.budgetCurrency = "Currency is required.";
    if (!formData.budget || isNaN(formData.budget))
      newErrors.budget = "Valid budget amount is required.";
    return newErrors;
  };
  useEffect(() => {
    setFormData((p) => ({ ...p, user_id: user?._id, phone:user?.mobileNumber, email:user?.email }));
  }, [user]);
  const handleChange = async (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      let country = await FetchCountryListdata();
      const selectedCountry = country.filter((item) => item.code === value);
      setFormData({
        ...formData,
        country: {
          name: selectedCountry[0].name,
          code: selectedCountry[0].code,
        },
      });
    } else if (name === "state") {
      let statess = await FetchStateListdata(formData?.country?.code);
      const selectedState = statess.filter((item) => item.code === value);
      setFormData({
        ...formData,
        state: { name: selectedState[0].name, code: selectedState[0].code },
      });
    } else if (name === "city") {
      let citiess = await FetchCityListdata(
        formData?.country?.code,
        formData?.state?.code
      );

      const selectedCities = citiess.filter((item) => item.name === value);
      setFormData({ ...formData, city: selectedCities[0]?.name });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const postCustomArtCallback = (res) => {
    setLoading(false);
    if (res.status === "success") {
      toastr.success("Request has been submitted successfully.");
      setFormData((p) => ({
        ...p,
        description: "",
        size: "",
        frame_type: "",
        full_name: "",
        email: "",
        phone: "",
        wp_num: "",
        address: "",
        country: { name: "", code: "" },
        city: "",
        state: { name: "", code: "" },
        zip: "",
        budgetCurrency: "",
        budget: "",
        file_name: "",
        link: "",
        water_mark_image_link: "",
        refrence_arts: []
      }));
      dispatch(listCustomArt({ user_id: user?._id }));

      setimages([]);
      setImageURLs("");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const uploadCallback = (name) => async (response) => {
      console.log("fasdfasvzxczres", response)
      if (response.status === "success") {
        setLoading(false);

        dispatch(
          postCustomArt(
            {
              ...formData,
              refrence_arts: response.data
            },
            postCustomArtCallback
          )
        );
      }
    };

    // var formDataimg = new FormData();
    // const art = "CustomArt";
    // formDataimg.append("category", art);
    // let lastimage = {};
    // for (const key of Object.keys(images)) {
    //   lastimage = images[key];
    // }
    const formDataimg = new FormData();
    images.forEach((image) => {
      formDataimg.append("images", image); // 'images' must match multer field name
    });

    // Optional: add additional fields
    formDataimg.append("user_id", user);
    formDataimg.append("category", "CustomArt");

    dispatch(uploadMultiFile(formDataimg, uploadCallback("images")));
    // dispatch(uploadArt(formDataimg, uploadCallback("images")));
  };
  useEffect(() => { console.log("images", images, "imageURLS", imageURLs) }, [images, imageURLs])
  useEffect(() => {
    if (formData?.country?.code) {
      fucntionToFetchStates(formData?.country?.code);
    }
  }, [formData?.country?.code]);

  const fucntionToFetchCountries = async () => {
    let country = await FetchCountryListdata();
    setCountries(country);
  };

  useEffect(() => {
    if (formData?.country?.code && formData?.state?.code) {
      fucntionToFetchCities(formData?.country?.code, formData?.state?.code);
    }
  }, [formData?.country?.code, formData?.state?.code]);

  const fucntionToFetchStates = async (code) => {
    let statesdata = await FetchStateListdata(code);
    setStates(statesdata);
  };

  const fucntionToFetchCities = async (countryCode, cityCode) => {
    let cities = await FetchCityListdata(countryCode, cityCode);
    setCities(cities);
  };
  useEffect(() => {
    fucntionToFetchCountries();
  }, []);

  useEffect(() => {
    if (
      authToken == null ||
      authToken == undefined ||
      !authToken ||
      authToken === ""
    ) {
      toastr.error("Please login");
      navigate("/login");
    }
  }, [formData]);

  const onChangeHandlerImage = async (e) => {
    console.log("tis is sdcsfd");
    let images = e.target.files;
    if (images.length < 1) return;
    for (let i = 0; i < images.length; i++) {
      const ext = images[i].name.split(".").pop().toLowerCase();
      if (ext !== "png" && ext !== "jpg" && ext !== "jpeg" && ext !== "heic") {
        toastr.error(
          "Invalid file format. Please upload a JPG, JPEG, HEIC & PNG image."
        );
        return;
      }
      for (let i = 0; i < images.length; i++) {
        if (images[i] && images[i].size >= 50 * 1e7) {
          toastr.error(
            "File size exceeds the limit. Please choose a smaller image."
          );
          return false;
        }
      }

      if (ext === "heic") {
        const blobfile = e.target.files[0];
        const blobURL = URL.createObjectURL(blobfile);
        const name = e.target.files[0].name.replace(/\s/g, "").split(".")[0];
        const resultBlob = await heic2any({
          blob: await (await fetch(blobURL)).blob(),
          toType: "image/jpg",
          quality: 1,
        });

        const converted_file = new File([resultBlob], name + ".jpg", {
          type: "image/jpeg",
          lastModified: new Date().getTime(),
        });

        const reader = new FileReader();
        reader.readAsDataURL(converted_file);

        reader.onload = (e) => {
          setImageURLs((prev) => [...prev, e.target.result]);
          setimages((prevImages) => prevImages.concat(converted_file));
        };
      } else {
        setimages((prevImages) => prevImages.concat(images[0]));
        const fileArray = Array.from(images).map((file) =>
          URL.createObjectURL(file)
        );
        setImageURLs(prev => [...prev, ...fileArray]);
      }
    }
  };

  const handleRemoveImage = (index) => {
    setimages(prev => prev.filter((_, i) => i !== index));
    setImageURLs(prev => prev.filter((_, i) => i !== index));
  };

  useEffect(() => {
    console.log("images", images);
    console.log("imageURLs", imageURLs);
  }, [images, imageURLs]);

  // list custom art
  useEffect(() => {
    if (user?._id) {
      const listCallback = (res) => {
        console.log("res", res);
      };
      dispatch(listCustomArt({ user_id: user?._id }, listCallback));
    }
  }, [user?._id]);

  const statusClassMap = {
    pending: "pending-text",
    inprogress: "inProgress",
    completed: "completed",
    expired: "expired",
  };

  const statusLabelMap = {
    pending: "Pending",
    inprogress: "In Progress",
    completed: "Completed",
    expired: "Expired",
  };

  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(5);
  var [sNoValue, setSNovalue] = useState(0);
  const [search, setSearch] = useState("");
  useEffect(() => {
    setData(CustomArts);
  }, [CustomArts]);
  useEffect(() => {
    var x = 0;
    if (data?.length < 4) {
      x = 1;
    } else {
      x = Math.ceil(data.length / 5);
    }
    for (let i = 1; i <= x; i++) {
      if (!dataLength.includes(i)) {
        dataLength.push(i);
      }
    }
  }, [data, dataLength]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 5);
    for (let i = values - 5; i < values; i++) {
      if (data[i]) {
        arr.push(data[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, data, search]);

  const handlePagination = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 5;
    } else if (val === "<") {
      valu = parseInt(values) - 5;
    } else if (val === ">" && sNoValue / 5 < values) {
      valu = (parseInt(values / 10) + 1) * 5;
    } else if (val === ">>" && values < data.length) {
      valu = Math.ceil(data.length / 5) * 5;
    } else {
      valu = parseInt(val) * 5;
    }
    setValues(valu);
  };

  useEffect(() => {
    if (CustomArts?.length > 0) {
      setData(
        CustomArts?.filter((item) => {
          if (!search) return item; // If search is empty, return all items.

          const searchLower = search.toLowerCase();
          const name = item?.nft_id?.name?.toLowerCase() || ""; // Safely handle null/undefined.
          const trackId = item?.order_track_id?.toLowerCase() || ""; // Safely handle null/undefined.

          // Check if either `name` or `trackId` includes the search string.
          return name.includes(searchLower) || trackId.includes(searchLower);
        })
      );
    }
  }, [search, CustomArts]);
  useEffect(() => {
    setDataLength([1]);
    setValues(5);
  }, [search]);
  const eyeBtn = (item) => {
    if (ViewArt === false) {
      //   setPrintRequest(item)
    } else {
      //   setPrintRequest()
    }
    setViewArt(!ViewArt);
  };

  console.log("formdata", formData)
  return (
    <>
      {(loading|| loading2) && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <div className="customArtFormBox">

        <p className="turn-on-text">Turn Your Idea into Custom Art</p>
        <p className="p">
          Fill out the form below to initiate your personalized art commission.
          Our team will review your request and get back to you with a quote.
        </p>
        <div>
          <p className="artwork-details">Artwork Details</p>
          <form>
            <div className="col mb-3">
              <label className="mb-2 label">Description of Artwork</label>
              <textarea
                name="description"
                className="form-control"
                placeholder="Describe your vision, specific elements, color palette, desired mood, or any reference points."
                value={formData.description}
                onChange={handleChange}
              />
            </div>
            <div className="col mb-3">
              <label className="mb-2 label">
                Upload Artwork References (If any)
              </label>

              {/* Always show upload box */}
              <div className="upload-container">
                <div className="upload-box">
                  <div className="upload-icon">
                    <img src="../../images/svg/upload-04.svg" alt="upload" />
                  </div>
                  <p className="drag-text">
                    Drag & drop files here, or{" "}
                    <span className="browse-text">click to browse</span>
                  </p>
                  <p className="file-size-info">
                    Max file size: 10MB (JPG, PNG)
                  </p>
                  <input
                    name="image"
                    type="file"
                    className="file-input"
                    accept=".png,.jpg,.jpeg"
                    onChange={onChangeHandlerImage}
                  />
                </div>
              </div>

              {/* Show preview only if image is selected */}
              <div className="row relative mt-3">
                {imageURLs.length > 0 && imageURLs.map((item, i) => (
                  <div className="col-xl-2">
                    <div className="position-relative border rounded overflow-hidden">
                      <img
                        src={item}
                        alt="preview"
                        className="w-full preview-image-section object-cover"
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveImage(i)}
                        className="btn p-0 position-absolute top-0 end-0  text-white mt-1 me-1 "
                      >
                        <img src="/images/svg/closeIconDialog.svg" width={20} alt="Remove" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>


            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="mb-2 label">Choose Painting Size* (In Centimeters)</label>
                <div>
                  <select
                    className="form-select form-control mb-2"
                    name="size"
                    required
                    value={formData.size}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select size
                    </option>
                    {sizes.map((item)=>
                    <option value={item}>{item}</option>
)}
                  </select>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label className="mb-2 label">Choose Frame Type*</label>
                <div>
                  <select
                    className="form-select form-control mb-2"
                    name="frame_type"
                    value={formData.frame_type}
                    onChange={handleChange}
                  >
                    <option value="" selecteed disabled>Select Frame</option>
                    {frames.map((item, index)=>
                    <option key={index} value={item}>{item}</option>)}
                    {/* <option value="modern">Modern</option> */}
                  </select>
                </div>
              </div>
            </div>

            <hr />
            <div>
              <p className="artwork-details">Contact Information</p>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="mb-2 label">Full Name</label>
                  <div>
                    <input
                      className="form-control form-control mb-2"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="mb-2 label">Email Address</label>
                  <div>
                    <input
                      className="form-control form-control mb-2"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="mb-2 label">Phone Number</label>
                  <div>
                    <input
                      className="form-control form-control mb-2"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="mb-2 label">Whatsapp Number</label>
                  <div>
                    <input
                      className="form-control form-control mb-2"
                      name="wp_num"
                      value={formData.wp_num}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <hr />
            </div>

            <div>
              <p className="artwork-details">Shipping & Budget</p>
              <div className="col mb-3">
                <label className="mb-2 label">Shipping Address</label>
                <div>
                  <input
                    className="form-control form-control mb-2"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="mb-2 label">Country</label>
                  <div>
                    <select
                      className="form-select form-control mb-2"
                      name="country"
                      value={formData.country?.code}
                      onChange={handleChange}
                    >
                      <option value="">Select Country</option>
                      {countries?.map((country) => (
                        <option
                          key={country.code}
                          name={country.code}
                          value={country.code}
                        >
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3 mb-3">
                  <label className="mb-2 label">State</label>
                  <div>
                    <select
                      className="form-select form-control mb-2"
                      name="state"
                      value={formData.state?.code}
                      onChange={handleChange}
                    >
                      <option value="">Select State</option>
                      {states?.map((state) => (
                        <option
                          key={state.code}
                          name={state.code}
                          value={state.code}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <label className="mb-2 label">City</label>
                  <div>
                    <select
                      className="form-select form-control mb-2"
                      name="city"
                      value={formData?.city}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select City
                      </option>
                      {cities?.map((state) => (
                        <option
                          key={state.code}
                          name={state.name}
                          value={state.name}
                        >
                          {state.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <label className="mb-2 label">ZIP</label>
                  <div>
                    <input
                      className=" form-control mb-2"
                      name="zip"
                      value={formData.zip}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div>
                    <label className="mb-2 label">Timeline</label>
                    <DatePicker
                      className=" form-control"
                      onChange={(value) => {
                        if (value) {
                          const selectedDate = moment(value.$d).format("YYYY-DD-MM");
                          setDates([selectedDate]);
                          setFormData((p)=>({...p, timeline:selectedDate}))
                        } else {
                          setFilter((prev) => ({
                            ...prev,
                            starting_day: "1970-01-01",
                            day: todaysDate,
                          }));
                        }
                      }}
                      disabledDate={disabledDate}
                      allowClear
                    />
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="row">
                    <label className="mb-2 label">Budget</label>
                    <div className="col-md-1">
                      <select
                        className="form-select form-control mb-2"
                        name="budgetCurrency"
                        value={formData.budgetCurrency}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          $
                        </option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <input
                        className="form-control"
                        name="budget"
                        value={formData.budget}
                        onChange={handleChange}
                        placeholder="Amount"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <button className="submit-artwork-btn" onClick={handleSubmit}>
                  Submit Artwork request
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="text-justify ">
        <p className="artwork-details my-4">Custom Artwork Request</p>
        <div className="table-responsive">
          <table className="nftlistTable nftsalehist">
            <thead>
              <tr>
                <td className=" date-div">
                  Date
                  <img src="../../images/svg/color-filter.svg" />
                </td>
                <td className="description-div">Description</td>
                <td className="w-custom">
                  Budget
                  <img src="../../images/svg/color-filter.svg" />
                </td>
                <td className="w-custom">Status</td>
                <td className="w-custom">Action</td>
              </tr>
            </thead>
            <tbody>
              {!!dataAfterPagination &&
                dataAfterPagination.length > 0 &&
                dataAfterPagination.map((item, index) => (
                  <tr>
                    <td className=" date-div">{item?.createdAt}</td>
                    <td className="description-div view-text-div">
                      {" "}
                      {item?.description}{" "}
                      {/* <span className="view-more-text">view more...</span> */}
                    </td>
                    <td className="view-more-text w-custom">${item?.budget}</td>
                    <td
                      className={`${statusClassMap[item?.print_status]
                        } w-custom`}
                    >
                      {statusLabelMap[item?.print_status] || "Unknown"}
                    </td>
                    <td className="w-custom">
                      <img
                        className="d-block m-auto"
                        src="../../images/svg/Eye.svg"
                        onClick={eyeBtn}
                        alt="Open Tracker"
                      />
                      <Modal
                        className="EmailVerifyBoxModel printDialog "
                        show={ViewArt}
                        centered
                        animation={false}
                        onHide={() => setViewArt(false)}
                      >
                        <FullfillmentDialog customArt={item} handleClose={() => setViewArt(false)} />
                      </Modal>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {dataAfterPagination.length > 0 && (
            <Col lg={12} className="text-end">
              <Pagination
                className="paginationNew"
                aria-label="Page  navigation example"
              >
                {values > 5 && (
                  <div className="d-flex align-items-center gap-2">
                    <PaginationItem>
                      <PaginationLink
                        first
                        href="#"
                        onClick={() => handlePagination("<<")}
                      />
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#"
                        previous
                        onClick={() => handlePagination("<")}
                      />
                    </PaginationItem>
                  </div>
                )}
                {dataLength &&
                  dataLength.map((item) => (
                    <PaginationItem
                      className={parseInt(item) === values / 5 ? "active" : ""}
                    >
                      <PaginationLink
                        href="#"
                        onClick={() => handlePagination(item)}
                      >
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  ))}

                {values < data.length && (
                  <div className="d-flex align-items-center gap-2">
                    <PaginationItem>
                      <PaginationLink
                        href="#"
                        next
                        onClick={() => handlePagination(">")}
                      />
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#"
                        last
                        onClick={() => handlePagination(">>")}
                      />
                    </PaginationItem>
                  </div>
                )}
              </Pagination>
            </Col>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomArtForm;
